module.exports = __webpack_public_path__ + "static/media/nucleo.5987dd12.woff2";